/**
 * MIT License
 *
 * Copyright (c) 2025 Chris M. Perez
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Predicate } from 'effect';
import { getGlobalTracing } from './global.js';

let signalCounter = 0;

export const traceSignalCreate = (
	name: string | undefined,
	initialValue: unknown
): string => {
	const tracing = getGlobalTracing();
	const signalId = name ?? `signal_${String(++signalCounter)}`;

	if (
		Predicate.isNotNullable(tracing) &&
		tracing.isCategoryEnabled('signals')
	) {
		tracing.log('signals', 'create', signalId, {
			initial: initialValue,
		});
	}

	return signalId;
};

export const traceSignalUpdate = (
	signalId: string,
	prevValue: unknown,
	nextValue: unknown
): void => {
	const tracing = getGlobalTracing();
	if (
		!Predicate.isNotNullable(tracing) ||
		!tracing.isCategoryEnabled('signals')
	)
		return;

	tracing.log('signals', 'update', signalId, {
		prev: prevValue,
		next: nextValue,
	});
};

export const traceComputedCreate = (name: string | undefined): string => {
	const tracing = getGlobalTracing();
	const computedId = name ?? `computed_${String(++signalCounter)}`;

	if (
		Predicate.isNotNullable(tracing) &&
		tracing.isCategoryEnabled('signals')
	) {
		tracing.log('signals', 'computed', computedId);
	}

	return computedId;
};
